import type { SwiperOptions } from 'swiper/types'

import { useUserStore } from '@frontend/libs/stores/useUserStore'
import { ImageSize } from '@frontend/libs/types/media'
import { cn, Image } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { Link } from 'react-router-dom'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import type { LookBook } from '../libs/type'

const swiperOptions: SwiperOptions = {
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
  },
  loop: true,
  modules: [Pagination],
  pagination: {
    clickable: true,
    el: '.swiper-pagination',
    enabled: true,
  },
  slidesPerView: 1,
}

export type LookBookSliderProps = LookBook

export function LookBookSlider(
  props: Readonly<LookBookSliderProps>,
): React.JSX.Element {
  const { shopGridView } = useUserStore((state) => state)

  const { link } = props

  if (link) {
    return (
      <div
        className={cn({
          'col-span-2 md:col-span-2': shopGridView === 'three-col',
          'col-span-2 md:col-span-3': shopGridView === 'four-col',
        })}
      >
        <Link className="block" target={link.target} to={link.url}>
          <Slider {...props} />
        </Link>
      </div>
    )
  }

  return (
    <div
      className={cn({
        'col-span-2 md:col-span-2': shopGridView === 'three-col',
        'col-span-2 md:col-span-3': shopGridView === 'four-col',
      })}
    >
      <Slider {...props} />
    </div>
  )
}

export default LookBookSlider

function Slider({
  gallery,
  title,
}: Readonly<LookBookSliderProps>): React.JSX.Element {
  const { shopGridView } = useUserStore((state) => state)

  return (
    <>
      <Swiper {...swiperOptions} className="h-auto!">
        {gallery?.map((image) => (
          <SwiperSlide
            className={cn('relative', {
              'aspect-[1277/652.66]': shopGridView === 'four-col',
              'aspect-[1277/936.66]': shopGridView === 'three-col',
            })}
            key={image.id}
          >
            <Image
              alt={image.alt}
              className="absolute left-0 top-0 h-full w-full object-cover"
              removeWrapper
              src={image.sizes[ImageSize.Full]}
              width={1500}
            />
          </SwiperSlide>
        ))}
        <div className="swiper-pagination"></div>
      </Swiper>
      {title && (
        <h4 className="mt-2 text-lg font-medium text-primary md:mt-4 md:text-xl">
          {title}
        </h4>
      )}
    </>
  )
}
